import { NotificationStore } from '@bingads-webui/notification-service';
import { trimEndSlash } from './utils';

export const defineResources = (ccBaseUrl) => {
  NotificationStore.defineRestResource('queueNotifications', {
    uriPath: `${trimEndSlash(ccBaseUrl)}/notifications/queueNotifications`,
  });
  NotificationStore.defineRestResource('previewBarDismissState', {
    uriPath: `${trimEndSlash(ccBaseUrl)}/notifications/previewBarDismissState`,
  });
  NotificationStore.defineRestResource('whatsNewDismissState', {
    uriPath: `${trimEndSlash(ccBaseUrl)}/notifications/whatsNewDismissState`,
  });
};
